import React from 'react'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import useStyles, { StyledAccordion } from './styles'

interface UserPanelAccordionProps {
  title: string
  children?: any
}
const UserPanelAccordion: React.FC<UserPanelAccordionProps> = ({
  title,
  children
}) => {
  const [expanded, setExpanded] = React.useState(true)

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <StyledAccordion
        expanded={expanded}
        elevation={0}
        square
        onChange={() => {
          setExpanded(!expanded)
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <p data-testid={title} className={classes.heading}>
            {title}
          </p>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </StyledAccordion>
    </div>
  )
}

export default UserPanelAccordion
